import React, {useEffect } from "react";
import { Code2, Globe, Server } from 'lucide-react';
import AOS from "aos";
import "aos/dist/aos.css";


function About() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: false,
      offset: 200,
    });

  }, []);
  return (
    <section id='about' className='py-20 bg-white dark:bg-gray-900'>
      <div className='container mx-auto px-4'>
        <h2 data-aos="slide-left" className='text-4xl font-bold text-center mb-16 bg-gradient-to-r from-blue-600 to-teal-400 bg-clip-text text-transparent'>
          About Me
        </h2>

        <div className='grid md:grid-cols-2 gap-12 items-center'>
          <div>
            <p data-aos="fade-up" className='text-lg text-gray-600 dark:text-gray-300 mb-6'>
              Hello! I am a passionate and detail-oriented Junior Full Stack Web
              Developer with experience in designing, developing, and
              maintaining responsive web applications. With a strong foundation
              in both front-end and back-end development, I specialize in
              creating dynamic and user-friendly solutions that meet client and
              business needs.
            </p>

            <p data-aos="fade-up" className='text-lg text-gray-600 dark:text-gray-300 mb-6'>
              I have hands-on experience working with modern frameworks like
              React, Node.js, and Laravel, as well as proficiency in building
              RESTful APIs and integrating third-party services. My ability to
              write clean, efficient code, combined with a keen eye for design
              and usability, allows me to deliver high-quality applications.
            </p>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
            <div data-aos="fade-up" className='p-6 bg-gray-50 dark:bg-gray-800 rounded-lg'>
              <Code2 className='w-12 h-12 text-blue-600 mb-4' />
              <h3 className='text-xl font-semibold mb-2'>
                Frontend Development
              </h3>
              <p className='text-gray-600 dark:text-gray-300'>
                Creating responsive and interactive user interfaces with modern
                frameworks.
              </p>
            </div>

            <div data-aos="fade-up" className='p-6 bg-gray-50 dark:bg-gray-800 rounded-lg'>
              <Server className='w-12 h-12 text-blue-600 mb-4' />
              <h3 className='text-xl font-semibold mb-2'>
                Backend Development
              </h3>
              <p className='text-gray-600 dark:text-gray-300'>
                Building robust and scalable server-side applications and APIs.
              </p>
            </div>

            <div data-aos="fade-up" className='p-6 bg-gray-50 dark:bg-gray-800 rounded-lg md:col-span-2'>
              <Globe className='w-12 h-12 text-blue-600 mb-4' />
              <h3 className='text-xl font-semibold mb-2'>
                Full Stack Solutions
              </h3>
              <p className='text-gray-600 dark:text-gray-300'>
                Delivering end-to-end web applications with seamless
                integration.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
